import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Tooltip, Popover, FloatButton } from "antd";
import { DoubleLeftOutlined } from "@ant-design/icons";
import {
  singleUploadToS3,
  multipleUploadToS3,
  storeTimerScreenShots,
} from "../../redux/actions/action";
import {
  SINGLE_UPLOAD_TO_S3,
  MULTIPLE_UPLOAD_TO_S3,
} from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../../assets/styles/local/TimerActivity.css";
import html2canvas from "html2canvas";

const TimerActivityRun = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const timerRunning = window.localStorage.getItem("timerRunning");
  const [isTimerRunning, setIsTimerRunning] = useState(
    localStorage.getItem("timerRunning") === "true"
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const localValue = localStorage.getItem("timerRunning") === "true";
      setIsTimerRunning(localValue);
    }, 2000); // check every 2 seconds

    return () => clearInterval(interval);
  }, []);

  console.log("asc timerRunning", isTimerRunning);

  const singleUploadToS3Res = useSelector(
    (state) => state.user.singleUploadToS3Res
  );

  const multipleUploadToS3Res = useSelector(
    (state) => state.user.multipleUploadToS3Res
  );

  const storeTimerScreenShotsRes = useSelector(
    (state) => state.user.storeTimerScreenShotsRes
  );

  const [storeImgData, setStoreImgData] = useState([]);

  const captureScreenshot = () => {
    html2canvas(document.documentElement).then((canvas) => {
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `screenshot_${Date.now()}.png`, {
            type: "image/png",
          });

          // Dispatch the file to Redux action for uploading to S3
          dispatch(singleUploadToS3(file));
        }
      }, "image/png");
    });
  };

  // Auto taking Screenshots in every 60 sec.
  useEffect(() => {
    let screenshotInterval;
    if (isTimerRunning) {
      console.log("asc timerRunning2", isTimerRunning);
      screenshotInterval = setInterval(() => {
        captureScreenshot();
      }, 20000); // 60 sec
    }
    return () => clearInterval(screenshotInterval);
  }, [isTimerRunning]);

  useEffect(() => {
    if (singleUploadToS3Res) {
      console.log("asc screens", singleUploadToS3Res);
      dispatch(storeTimerScreenShots(singleUploadToS3Res));
    }
  }, [singleUploadToS3Res]);

  useEffect(() => {
    if (storeTimerScreenShotsRes) {
      console.log("asc store screens", storeTimerScreenShotsRes);
      setStoreImgData(storeTimerScreenShotsRes.screenShotsUrl);
    }
  }, [singleUploadToS3Res, storeTimerScreenShotsRes]);

  return <div className=""></div>;
};

export default TimerActivityRun;
